import "./BottomSheet.scss";
import { Drawer } from "antd";
import { X } from "lucide-react";
import { ReactNode } from "react";

interface BottomSheetType {
  openBottomSheet: boolean;
  setOpenBottomSheet: (openBottomSheet: boolean) => void;
  children: ReactNode;
  onCloseAction?: () => void;
  title?: string;
  showGradient?: boolean;
  variant?: "success" | "error" | "info";
}

const BottomSheet = ({
  openBottomSheet,
  setOpenBottomSheet,
  children,
  title,
  showGradient = false,
  variant = "success",
  onCloseAction,
}: BottomSheetType) => {
  const onClose = () => {
    setOpenBottomSheet(false);
    console.log("Bottom sheet closed");

    if (onCloseAction) {
      onCloseAction();
    }
  };

  const baseClasses =
    "w-full mx-auto h-[80px] absolute top-0 z-0 left-0 right-0  transition-colors duration-200 rounded-t-[20px]";
  const variantClasses = {
    success: "bg-green-gradient",
    error: "bg-red-gradient",
    info: "bg-yellow-gradient",
  };

  const classes = `
    ${baseClasses}
    ${variantClasses[variant]}
  `
    .trim()
    .replace(/\s+/g, " ");

  return (
    <Drawer placement="bottom" closable={false} onClose={onClose} className="!block md:hidden ant-drawer-bottom-sheet" open={openBottomSheet}>
      <div className="bottom-sheet-top block md:!hidden">
        <p className="title">{title}</p>
        {/* <button onClick={onClose} className="bottom-sheet-cancel-button  cursor-pointer">
          <X  color="white"/>
        </button> */}
      </div>
      <div className="content-container max-h-[80vh]">
        {showGradient && <div className={classes}></div>}
         <button onClick={onClose} className=" absolute top-4 right-4 z-50 p-2 hover:bg-gray-100 rounded-full transition-colors">
          <X     />
        </button>


        {children}
      </div>  
    </Drawer>
  );
};

export default BottomSheet;
